/**
 * This is the base JS file which gets transpiled by babel according to the browserslist config.
 */
/* eslint-disable import/first, import/no-unassigned-import */

import 'url-search-params-polyfill';
import { h, render } from 'preact';
import gaTracking from './utility/ga-tracking';
import PolyfillsCustom from './utility/polyfills';
import AccordionComponent from './components/accordion';
import Tabs from './components/tabs';
import InstitutionsSelect from './components/institutions-select';
import CounterReports from './components/counter-reports';
import Counter5Reports from './components/counter-reports5';
import UsageReports from './components/usage-reports';
import DateRangeValidation from './components/date-range-validation';
import ValidateInput from './utility/validate-input';
import nodeListForEach from './utility/node-list-foreach';
import { addEventListenerCheckboxPatronConfirmation, hideErrorMessageOnBlur } from './utility/content-on-demand';
import enableCardFlipping from './components/flippable-card';
import copyToClipboard from "./components/copy-to-clipboard.js";
import readMore from './components/read-more.js'
import scrollIntoView from './utility/scroll-into-view.js'
import MarcRecords from './components/marc-records/marc-records.js';
import modalVideo from './components/modal-video.js';
import coremediaEdit from './components/coremedia-edit.js';

// Preact components
import AssociatedUsersApp from './components/associated-users/app.js';

// pages
import * as journalPerformancePage from './components/journal-performance/journal-performance';
import { enhanceAskForPriceForms } from './components/journal-denials';
// import visbilityCookie from "./components/hide-if-cookie";

PolyfillsCustom.initializePolyfills();

const counterReports = new CounterReports({
	counterReportsForm: '[data-js="counter-reports-form"]',
	counterReportsWrapperSelector: '[data-js="counter-reports-wrapper"]',
	dateValidation: DateRangeValidation
});
counterReports.init();

const dateFormat = 'year-month';
const counter5ReportsPr = new Counter5Reports({
	counterReports5Form: 'pr-counter5-form',
	hasYop: false,
	formPrefix: 'pr',
	dateValidationConfigs: [
		{
			startDateId: 'pr-date-from',
			endDateId: 'pr-date-to',
			dateFormat
		}
	]
});
counter5ReportsPr.init();

const counter5ReportsTr = new Counter5Reports({
	counterReports5Form: 'tr-counter5-form',
	hasYop: true,
	formPrefix: 'tr',
	dateValidationConfigs: [
		{
			startDateId: 'tr-date-from',
			endDateId: 'tr-date-to',
			dateFormat
		}
	]
});
counter5ReportsTr.init();

const counter5ReportsDr = new Counter5Reports({
	counterReports5Form: 'dr-counter5-form',
	hasYop: false,
	formPrefix: 'dr',
	dateValidationConfigs: [
		{
			startDateId: 'dr-date-from',
			endDateId: 'dr-date-to',
			dateFormat
		}
	]
});
counter5ReportsDr.init();

if (/complete|interactive/.test(document.readyState)) {
	document.body.classList.add('js');
	window.BPID = document.body.getAttribute('data-bpid');
	const { pathname } = window.location;

	// please leave this commented out for now
	// const env = 'ENVIRONMENT';
	// if (env === '"development"') {
	// 	console.log('bla 2', env);
	// import 'preact/devtools';
	// }

	const associatedUsersPanel = document.querySelector('.js-associated-users');
	if (associatedUsersPanel && pathname.match('/access')) {
		render(<AssociatedUsersApp />, associatedUsersPanel);
	}

	const institutionsCount = document.querySelector('body').getAttribute('data-admin');
	if (institutionsCount > 0) {
		const accordionComponent = new AccordionComponent();
		accordionComponent.init();
	}

	const accordionComponent = new AccordionComponent();
	accordionComponent.init();


	const institutionsSelect = new InstitutionsSelect({
		institutionLinkElement: '[data-type="institution-link"]',
		institutionsSelectElement: '[data-type="institutions-select"]'
	});
	institutionsSelect.init();

	const tabs = document.querySelectorAll('[data-component="c-tabs"]');
	nodeListForEach(tabs, tab => {
		new Tabs(tab).init();
	});

	const usageReports = new UsageReports({
		startDateId: 'usage-report-date-from',
		endDateId: 'usage-report-date-to',
		dateFormat: 'year-month-day'
	});
	usageReports.init();

	const validateInput = new ValidateInput({
		inputId: 'cod-password',
		inputFormSelector: '[data-js="cod-password"]'
	});
	validateInput.init();

	if (pathname.match('/content-on-demand')) {
		addEventListenerCheckboxPatronConfirmation();
		hideErrorMessageOnBlur('#usage-report-date-from', '#error-cod-usage-report-empty', '#error-cod-usage-report-failed')
		hideErrorMessageOnBlur('#usage-report-date-to', '#error-cod-usage-report-empty', '#error-cod-usage-report-failed')
	}

	if (pathname.match('/marc')) {
		new MarcRecords();
	}

	if (pathname.match('/order?')) { // The trailing "/" character in the match string is of importance, otherwise this would also match on the order-history page
		copyToClipboard({
			buttonToCopy: '[data-js^="copy_button-isbn-"]',
			contentToCopy: '[data-js^="copy_content-isbn-"]'
		});
	}
	if (pathname.match('/consortia?')) {
		copyToClipboard({
			buttonToCopy: '[data-copy-js^="copy_button-id-"]',
			contentToCopy: '[data-copy-js^="copy_text-id-"]'
		});
	}

	if (pathname.match('/usage?')) {
		copyToClipboard({
			buttonToCopy: '[data-js^="copy_button-sushi"]',
			contentToCopy: '[data-js^="copy_content-sushi"]'
		});
	}
	if (pathname.match('/counter-5-1?')) {
		copyToClipboard({
			buttonToCopy: '[data-js^="copy_button-sushi"]',
			contentToCopy: '[data-js^="copy_content-sushi"]'
		});
	}

	if (pathname.match('/journal-performance')) {
		journalPerformancePage.init();
	}

	if (pathname.match('/journal-denials')) {
		enhanceAskForPriceForms();
	}

	if (pathname.match('/consortia')) {
		new CopyValuesToClipboard({
			alertBoxId: '#members-copy-values-confirmation',
			closeButtonId: '#button-close-members-copy-values-confirmation',
			tableSelector: '[data-js="copy-bpid-table"]',
			cellNumberValue: 1,
			cellNumberButton: 2
		}).init();
	}


	const modalCount = document.querySelectorAll('[data-modal-for]');
	const videoCount = document.querySelectorAll('.video-container');
	if (modalCount.length > 0 && videoCount.length > 0) {
		modalVideo();
	}

	if (pathname.match('/counter-5-1')) {
		scrollIntoView('[data-js="scrollIntoView"]');
	}

		enableCardFlipping();

	if (pathname.match('/updates?')) {
		readMore();
	}

	if (document.querySelectorAll('[data-coremedia]').length > 0) {
		coremediaEdit();

	}

}
